module.exports = __webpack_public_path__ + "img/patreon.2e43d370.jpeg";